.scroll {
  overflow-x: auto;
  border: 1px solid var(--hs-color-border-default);
  border-radius: var(--hs-radius-md);
  background: var(--hs-color-bg-surface);
}
.scroll:focus-visible {
  outline: none;
  box-shadow: var(--hs-focus-lavender);
}
.table {
  width: 100%;
  border-collapse: collapse;
  color: var(--hs-color-text-primary);
  font: var(--hs-type-body-s);
  text-align: start;
}
.caption {
  padding: var(--hs-spacing-3) var(--hs-spacing-4);
  font: var(--hs-type-label);
  text-align: start;
}
.hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
.head {
  padding: var(--hs-spacing-3) var(--hs-spacing-4);
  border-bottom: 1px solid var(--hs-color-border-default);
  background: var(--hs-color-bg-subtle);
  color: var(--hs-color-text-secondary);
  font: var(--hs-type-caption);
  letter-spacing: var(--hs-caption-ls);
  text-align: start;
  text-transform: uppercase;
  white-space: nowrap;
}
.cell {
  padding: var(--hs-spacing-3) var(--hs-spacing-4);
  border-bottom: 1px solid var(--hs-color-border-default);
  font-weight: inherit;
  text-align: start;
  vertical-align: top;
}
.dense .cell,
.dense .head {
  padding-block: var(--hs-spacing-2);
}
.primary {
  color: var(--hs-color-text-primary);
  font: var(--hs-type-label);
}
.end {
  text-align: end;
}
.row:hover > .cell {
  background: var(--hs-color-bg-sunken);
}
/* A row and what is said under it read as one record. */
.withDetail > .cell {
  border-bottom: 0;
}
.detail > .cell {
  padding-top: 0;
}
tbody > tr:last-child > .cell {
  border-bottom: 0;
}
.empty {
  padding: var(--hs-spacing-8) var(--hs-spacing-4);
  color: var(--hs-color-text-secondary);
  text-align: center;
}
